import { buildBannerCard, buildLinkPreviewCard, buildThumbnailCard } from 'fym-shared/src/music24/story/cardCopy';
import { KIT_BANNER_SITES, type KitCard } from 'fym-shared/src/music24/story/kitCard';
import type { StoryPreviewContext } from '../details/imageTiles/storyPreviewContext';

/**
 * The kit cards of the Studio preview of an asset type, with the texts of the render (the same
 * builders as music24-api `buildKitCard`): the three banners (YouTube, X, Facebook), the YouTube
 * thumbnail of the audio upload ("Official audio"), the link preview of the SmartLink (its state by
 * the release date). Null for an asset type that is not a card. Pure.
 */
export function studioCards(assetTypeId: string, context: StoryPreviewContext): KitCard[] | null {
  if (assetTypeId === 'banners') {
    return KIT_BANNER_SITES.map((site) =>
      buildBannerCard({
        site,
        title: context.title,
        artist: context.artist,
        releaseDate: context.releaseDate,
        today: context.today,
        link: context.link,
        locale: context.locale,
      })
    );
  }
  if (assetTypeId === 'thumbnail') {
    // The Studio makes the audio thumbnail; a kit video brings its own (design asset-redesign i).
    return [
      buildThumbnailCard({ video: 'audio', title: context.title, artist: context.artist, locale: context.locale }),
    ];
  }
  if (assetTypeId === 'linkPreview') {
    return [
      buildLinkPreviewCard({
        title: context.title,
        artist: context.artist,
        releaseDate: context.releaseDate,
        today: context.today,
        locale: context.locale,
      }),
    ];
  }
  return null;
}
